<template lang="html">

  <section class="popup-condiciones">

    <div class="popup">
      
      <h2>{{$t('popupterminos.titulo')}}</h2>

      <h3>{{$t('popupterminos.titulo_dos')}}</h3>

      <p>{{$t('popupterminos.titulo_tres')}}</p>


      <template v-for="e in $t('popupterminos.cuerpo')">
        <h3>{{e.titulo}}</h3>
        <p>{{e.cuerpo}}</p>
      </template>

      
      <h3>{{$t('popupterminos.titulo_mas')}}</h3>
      <p>{{$t('popupterminos.texto_mas')}} <router-link :to="$t('enlaces.datos_seguros')" target="blank">{{$t('popupterminos.datos_seguros')}}</router-link> {{$t('popupterminos.texto_nuestra')}}</p>

      

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'popup-condiciones',
  }
</script>

<style scoped lang="scss">
  .popup-condiciones {

    width: 50%;

    .popup{
      width: 100%;
      display: inline-block;
      padding: 0 20px;
      max-width: 768px;
      color: #FFFFFF;


      .cerrar{
        position: absolute;
        right: 10px;
        top: 0px;
        font-size: 30px;
      }

      h2{
        margin-bottom: 10px;
        width: 100%;
        text-align: left;
        display: inline-block;
        font-size: 14px;
        font-weight: 800;
      }

      h3{
        font-size: 13px;
        text-align: left;
        width: 100%;
        display: inline-block;
        font-weight: 600;
      }

      p{
        font-size: 12px;
        line-height: 18px;

        a{
          text-decoration: underline;
        }
      }

      .btn{
        margin-top: 30px;
      }
    }
  }

  @media screen and (max-width:830px){
    .popup-condiciones{
      width: 100%;
      .popup{
        padding: 0;
      }
    }

    form{
      flex-wrap: wrap;
    }
    
  }


</style>



// WEBPACK FOOTER //
// src/components/view-parts/contacto/popup-contacto.vue